import { render, staticRenderFns } from "./QScoreCardBonusLeads.vue?vue&type=template&id=e0cb3806&scoped=true&"
import script from "./QScoreCardBonusLeads.vue?vue&type=script&lang=js&"
export * from "./QScoreCardBonusLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cb3806",
  null
  
)

export default component.exports